import { createIconElement } from '@/lib';
import FlowsIcon from '@/assets/icons/ic-flows.svg';

interface FlowFormHeaderProps {
    flowName: string;
}

export const FlowFormHeader = ({ flowName }: FlowFormHeaderProps) => {
    return (
        <div className='hidden flex-col items-center justify-center gap-5 md:flex'>
            <div className='flex items-center justify-center'>
                {createIconElement(FlowsIcon, { className: 'size-10' })}
            </div>
            <div className='flex items-center justify-center'>
                <h2 className='text-heading-xl font-bold'>{flowName}</h2>
            </div>
        </div>
    );
};
